import React from "react";
import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes.jsx";
import Result from "./pages/Result";
import ReviewQuiz from "./pages/ReviewQuiz";
import * as Sentry from "@sentry/react";

import { initStudyTracking } from "./common/studyTimer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  useEffect(() => {
    const token = localStorage.getItem("token");
    const baseUrl = import.meta.env.VITE_APP_BASE_URL;

    function sendTimeToBackend(seconds) {
      const token = localStorage.getItem("token");

      // Check if token exists and is not empty
      if (!token || token.trim() === "" || seconds < 1) {
        // console.log("Study time tracking skipped:", {
        //   hasToken: !!token,
        //   tokenLength: token?.length,
        //   seconds,
        // });
        return;
      }

      fetch(`${baseUrl}/progress/progress2/study-time`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ seconds }),
      })
        .then((response) => {
          if (!response.ok) {
            console.error("Study time tracking failed:", {
              status: response.status,
              statusText: response.statusText,
            });

            // If unauthorized, the token might be expired
            if (response.status === 401) {
              console.warn(
                "Token might be expired. Consider logging out and logging in again."
              );
            }
          } else {
            console.log("Study time tracked successfully:", { seconds });
          }
        })
        .catch((error) => {
          console.error("Study time tracking error:", error);
        });
    }

    initStudyTracking(sendTimeToBackend);
  }, []);

  return (
    <>
      {/* <Routes>
        <Route path="/result" element={<Result />} />
        <Route path="/practice/review" element={<ReviewQuiz />} />
      </Routes> */}

      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>

      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />
    </>
  );
}

export default App;
